"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LoanCardBody = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("@navinc/utils");

var _baseReactComponents = require("@navinc/base-react-components");

var _offerStyles = require("./offer-styles");

var _details = require("./details");

var _index = _interopRequireWildcard(require("../match-factor-score/index.js"));

var _offerLinkAttributes = require("../util/offer-link-attributes");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LoanCardBody = function LoanCardBody(_ref) {
  var _loanOffer$name, _loanOffer$navEditori, _loanOffer$navEditori2, _loanOffer$image$high, _loanOffer$image, _loanOffer$applyUrl, _loanOffer$navEditori3, _loanOffer$navEditori4;

  var _ref$loanOffer = _ref.loanOffer,
      loanOffer = _ref$loanOffer === void 0 ? {} : _ref$loanOffer,
      order = _ref.order,
      detailLink = _ref.detailLink,
      onApplyNow = _ref.onApplyNow,
      loggedInPresets = _ref.loggedInPresets,
      locationUrl = _ref.locationUrl,
      enterpriseUuid = _ref.enterpriseUuid,
      client = _ref.client,
      _ref$shouldShowMF = _ref.shouldShowMF,
      shouldShowMF = _ref$shouldShowMF === void 0 ? loggedInPresets : _ref$shouldShowMF,
      _ref$shouldHideSignup = _ref.shouldHideSignup,
      shouldHideSignup = _ref$shouldHideSignup === void 0 ? loggedInPresets : _ref$shouldHideSignup,
      _ref$shouldShowQualif = _ref.shouldShowQualifiers,
      shouldShowQualifiers = _ref$shouldShowQualif === void 0 ? loggedInPresets : _ref$shouldShowQualif,
      showExtrapolatedToolTip = _ref.showExtrapolatedToolTip,
      category = _ref.category,
      referralName = _ref.referralName,
      referralTarget = _ref.referralTarget,
      referralType = _ref.referralType,
      _ref$disableApplyOnMa = _ref.disableApplyOnMatchFactorZero,
      disableApplyOnMatchFactorZero = _ref$disableApplyOnMa === void 0 ? false : _ref$disableApplyOnMa,
      _ref$shouldShowMatchF = _ref.shouldShowMatchFactorDescriptionDrawer,
      shouldShowMatchFactorDescriptionDrawer = _ref$shouldShowMatchF === void 0 ? false : _ref$shouldShowMatchF;
  var scrollWayPointRef = (0, _react.useRef)(null);
  var matchFactorScore = loanOffer.matchFactor;
  var shouldHideApply = disableApplyOnMatchFactorZero && matchFactorScore === 0;

  var trackNewTealiumConversion = function trackNewTealiumConversion() {
    (0, _utils.tealiumTrack)({
      tealium_event: 'referral',
      action: 'referral',
      category: category,
      label: locationUrl,
      matchFactorScore: matchFactorScore,
      accountId: enterpriseUuid,
      offerCategory: 'loans',
      offerId: loanOffer.id,
      offerName: loanOffer.name,
      offerSubCategory: '',
      offerBrand: loanOffer.issuer,
      order: order,
      referralName: referralName,
      referralTarget: referralTarget,
      referralType: referralType,
      rtid: loanOffer.rtid,
      rsid: loanOffer.rsid,
      offerLink: loanOffer.applyUrl,
      partnerId: '',
      client: client,
      value: 0
    });
  };

  var onApplyTrack = function onApplyTrack() {
    trackNewTealiumConversion();
    return !!onApplyNow && onApplyNow(loanOffer);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.ScrollWayPoint, {
      ref: scrollWayPointRef
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.FirstLook, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.OfferTitle, {
        size: "sm",
        bold: true,
        "data-testid": "loancard-v3:loan-title",
        children: (_loanOffer$name = loanOffer.name) !== null && _loanOffer$name !== void 0 ? _loanOffer$name : ''
      }), shouldShowMF && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.MatchFactorWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index["default"], {
          score: matchFactorScore,
          shouldShowMatchFactorDescriptionDrawer: shouldShowMatchFactorDescriptionDrawer
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.OfferDescription, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.AwardIcon, {
          name: "system/certified-ribbon"
        }), (_loanOffer$navEditori = (_loanOffer$navEditori2 = loanOffer.navEditorial) === null || _loanOffer$navEditori2 === void 0 ? void 0 : _loanOffer$navEditori2.summary) !== null && _loanOffer$navEditori !== void 0 ? _loanOffer$navEditori : '']
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.CtaWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.Logo, {
          src: (_loanOffer$image$high = (_loanOffer$image = loanOffer.image) === null || _loanOffer$image === void 0 ? void 0 : _loanOffer$image.high) !== null && _loanOffer$image$high !== void 0 ? _loanOffer$image$high : '',
          alt: "".concat(loanOffer.issuer, " logo")
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.ApplyButton, Object.assign({
          asAnchor: true,
          disabled: shouldHideApply,
          rel: "noopener noreferrer",
          target: "_blank",
          size: "large"
        }, (0, _offerLinkAttributes.offerLinkAttributes)(shouldHideApply ? null : (_loanOffer$applyUrl = loanOffer.applyUrl) !== null && _loanOffer$applyUrl !== void 0 ? _loanOffer$applyUrl : ''), {
          "data-testid": "loancard-v3:apply-button",
          onClick: onApplyTrack,
          children: "Apply now"
        })), detailLink && /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.DetailsLink, {
            href: "https://www.nav.com",
            target: "_blank",
            children: "See details, rates, & fees"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.BottomBorder, {
        children: [shouldShowMF && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.MatchFactorWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index["default"], {
            score: matchFactorScore,
            shouldShowMatchFactorDescriptionDrawer: shouldShowMatchFactorDescriptionDrawer
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.OfferDescription, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.AwardIcon, {
            name: "system/certified-ribbon"
          }), (_loanOffer$navEditori3 = (_loanOffer$navEditori4 = loanOffer.navEditorial) === null || _loanOffer$navEditori4 === void 0 ? void 0 : _loanOffer$navEditori4.summary) !== null && _loanOffer$navEditori3 !== void 0 ? _loanOffer$navEditori3 : '']
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.DetailsWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_details.Details, {
        onApplyTrack: onApplyTrack,
        loanOffer: loanOffer,
        shouldShowQualifiers: shouldShowQualifiers,
        shouldHideSignup: shouldHideSignup,
        showExtrapolatedToolTip: showExtrapolatedToolTip
      })
    })]
  });
};

exports.LoanCardBody = LoanCardBody;

var _default = (0, _styledComponents["default"])(LoanCardBody).withConfig({
  componentId: "sc-5uou7h-0"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=body.js.map